<template>
  <div>
    <v-card :style="[
      $vuetify.breakpoint.smAndDown
        ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
        : { 'background-color': '#f9f9f9' },
    ]">
      <div style="margin-left: 10px; margin-right: 10px">
        <v-row style="margin-top: 1px">
          <v-col cols="12" md="6">
            <div class="pt-8" style="
                font-size: 20px;
                margin-left: 1rem;
                margin-right: 1rem;
                color: #444444;
              ">
              Visitor Blacklist Management
            </div>
          </v-col>
          <v-col cols="12" md="3"></v-col>
          <v-col cols="12" md="3" style="text-align: right" class="mt-2">
            <!-- <v-select
              outlined
              :items="TowerList"
              label="Tower"
              item-text="towerName"
              item-value="towerID"
              v-model="TowerID"
              @change="getVisitorListByTowerID(TowerID)"
            ></v-select> -->
          </v-col>
        </v-row>

        <v-card-text>
          <div>
            <v-card elevation="10" style="padding: 2%; margin-bottom: 2%">

              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <v-text-field label="Search" append-icon="mdi-database-search-outline" v-model="search"
                    v-on:keyup.enter="getDataVisitor(search)" clearable outlined dense></v-text-field>

                </v-col>
                <v-col cols="12" sm="2" md="2" lg="2">
                  <v-autocomplete :items="['Active', 'Blacklist']" label="Status" v-model="activeStatus" required
                    clearable outlined dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" style="text-align: end">
                  <v-hover v-slot="{ hover }">
                    <v-btn :color="'blue'" class="ma-2 white--text" :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }" @click="SearchgetVisitorList()">
                      Search

                      <v-icon right> mdi-magnify </v-icon>
                    </v-btn>
                  </v-hover>
                
                    <v-btn v-if="permissionsPage.create" color="green" class="ma-2 white--text"
                      :elevation="2" 
                      @click="OpenVisitorDialog('create', null)">
                      Create
                      <v-icon right> mdi-plus </v-icon>
                    </v-btn>
                 
                </v-col>
              </v-row>
            </v-card>

            <v-card elevation="10" style="padding: 2%; margin-top: 2%; margin-bottom: 2%">
              <v-row>
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="5" align="center">
                  <v-pagination v-model="page" :total-visible="6" :length="pageCount"
                    @input="ChangePage(page)"></v-pagination>
                </v-col>
              </v-row>
              <v-data-table :headers="headers" :items="VisitorList" hide-default-footer style="color: #332f2fde"
                :items-per-page="itemsPerPage" :page.sync="page" single-line hide-details>
                <template v-slot:item="{ item, index }">
                  <tr
                    :style="[item.isBlockList ? { 'background-color': 'rgb(232, 34, 34,0.3)' } : { 'background-color': '#ffffff' },]">
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.firstnameTH + " " + item.lastnameTH }}</td>
                    <td class="header-table-css">{{ item.firstnameEN + " " + item.lastnameEN }}</td>
                    <td class="header-table-css">{{ item.documentNumber }}</td>
                    <!-- <td class="header-table-css">
                      {{ ChangeFormatDate(item.createTime) }}
                    </td>  -->
                    <td style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      ">
                      <v-btn :color="GetColor(item.isBlockList)" rounded class="text-capitalize" depressed
                        style="width: 100px">
                        <span :style="{ color: GetColorText(item.isBlockList) }">{{
                          item.isBlockList == true ? "Blacklist" : "Active"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center">
                      <v-btn class="mx-2" fab dark small color="orange" @click="OpenVisitorDialog('Edit', item)">
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>

                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination v-model="page" :total-visible="20" :length="pageCount"
                    @input="ChangePage(page)"></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete dense solo label="10/page" v-model="itemsPerPage" @input="ChangePerPage(itemsPerPage)"
                    :items="items"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="VisitorDialog" persistent max-width="800px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span v-if="EditStatus" class="text-h5">Edit Visitor</span>
          <span v-else class="text-h5">Create Visitor</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="2" md="2">
                <v-text-field label="Prefix EN" v-model="prefixEN" :disabled="EditStatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field label="Firstname EN" v-model="firstnameEN" :disabled="EditStatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field label="Lastname EN" v-model="lastnameEN" :disabled="EditStatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field label="Prefix TH" v-model="prefixTH" :disabled="EditStatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field label="Firstname TH" v-model="firstnameTH" :disabled="EditStatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field label="Lastname TH" v-model="lastnameTH" :disabled="EditStatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Document Number" v-model="documentNumber" :disabled="EditStatus"></v-text-field>
              </v-col>
                <v-col cols="12" sm="2" md="2" style="display: flex;
                align-items: center;
                justify-content: end;
                font-size: 24px;">
                <span >Blacklist</span>
              </v-col>
              <v-col cols="12" sm="2" md="2" style="display: flex;justify-content: center;">
                <v-switch v-model="isBlockList" hide-details inset ></v-switch>
              </v-col>
                  <v-col cols="12" sm="12" md="12">
                <v-text-field label="BlackList Reason" v-model="blockListReason" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="12" md="12" style="text-align: end; margin-bottom: 20px">
              <v-spacer></v-spacer>
              <v-btn v-if="permissionsPage.create && !EditStatus" class="ma-2" style="min-width: 100px" color="success"
                @click="ManageVisitor()">
                Save
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn v-if="permissionsPage.update && EditStatus" class="ma-2" style="min-width: 100px" color="success"
                @click="ManageVisitor()">
                Update
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn variant="outlined" color="silver" style="min-width: 100px" append-icon="mdi-close-circle-outline"
                @click="CloseVisitorDialog()">
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../../main";

export default {
  name: "VisitorBlacklist",
  components: {},
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      LoadingDialog: false,
      dialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      activeStatus: null,
      TowerList: [],
      LocationList: [],
      TowerID: null,
      VisitorList: [],
      FloorList: [],
      ZoneList: [],
      ProjectList: [],
      ZoneID: null,
      FloorID: null,
      ProjectID: null,
      startDate: "",
      endDate: "",
      menuStartDate: false,
      menuEndDate: false,
      activeSearch: null,
      VisitorDialog: false,
      EditStatus: false,

      id: null,
      prefixTH: "",
      prefixEN: "",
      blockListReason: "",
      documentNumber: "",
      firstnameEN: "",
      firstnameTH: "",
      isBlockList: null,
      lastnameEN: "",
      lastnameTH: "",
      // model Add/Edit
      VisitorID: null,
      VisitorName: "",
      MajorCode: "",
      MinorCode: "",
      Location: null,
      Active: null,
      permissionsPage: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "Name Th",
          align: "left",
          sortable: false,
        },
        {
          text: "Name En",
          align: "left",
          sortable: false,
        },
        {
          text: "Document Number",
          align: "left",
          sortable: false,
        },

        // {
        //   text: "CreateDate",
        //   align: "left",
        //   sortable: false,
        // },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;

    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    await self.getDataVisitor();
    // await self.getVisitorTower();
    // await self.getVisitorLocation();
    // await self.getFloorList();
    // await self.getZoneList();
    // await self.getProjectList();
  },

  methods: {

    async SearchgetVisitorList() {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search.trim(),
        isBlockList:
          self.activeStatus == "Blacklist"
            ? true
            : self.activeStatus == null
              ? null
              : false,
      };
      await axios
        .post(`${self.url}VMS/getDataVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.count / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    async getVisitorTower() {
      let self = this;
      self.LoadingDialog = true;
      // self.page = 1;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search
      };
      await axios
        .post(`${self.url}VMS/getVisitorTower`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.count / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        isBlockList:
          self.activeStatus == "Blacklist"
            ? true
            : self.activeStatus == null
              ? null
              : false,
      };
      axios
        .post(`${self.url}VMS/getDataVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.count / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.search == null ? "" : self.search,
        isBlockList:
          self.activeStatus == "Blacklist"
            ? true
            : self.activeStatus == null
              ? null
              : false,
      };
      axios
        .post(`${self.url}VMS/getDataVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.count / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    getDataVisitor(data) {
      let self = this;
      self.LoadingDialog = true;
      // self.page = 1; 
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: data,
        isBlockList:
          self.activeStatus == "Blacklist"
            ? true
            : self.activeStatus == null
              ? null
              : false,
      };
      axios
        .post(`${self.url}VMS/getDataVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.count / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
            self.LoadingDialog = false;
          }
          
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear()
      );
    },

    GetColor(value) {
      if (value == false) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == false) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    async searchgetVisitorTower() {
      let self = this;
      await axios
        .get(`${self.url}Visitor/getVisitorTower`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TowerList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    async getFloorList() {
      let self = this;
      await axios
        .get(`${self.url}Visitor/getFloorList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.FloorList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    async getZoneList() {
      let self = this;
      await axios
        .get(`${self.url}Visitor/getZoneList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ZoneList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    getProjectList() {
      let self = this;
      axios
        .get(`${self.url}Visitor/getProjectList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ProjectList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    async getVisitorLocation() {
      let self = this;
      await axios
        .get(`${self.url}Visitor/getVisitorLocation`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LocationList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    getVisitorListByTowerID(data) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        towerID: data,
      };
      axios
        .post(`${self.url}Visitor/getVisitorListByTowerID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.VisitorList = response.data.data.listData;
            self.pageCount = Math.ceil(
              response.data.data.count / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    OpenVisitorDialog(module, data) {
      let self = this;
      if (module == "create") {
        self.clear();
        self.VisitorDialog = true;
      } else {
        self.BindingEditData(data);
      }
    },

      clear() {
      let self = this;
      self.id = null;
      self.prefixTH= "";
      self.prefixEN= "";
      self.blockListReason= "";
      self.documentNumber= "";
      self.firstnameEN= "";
      self.firstnameTH= "";
      self.isBlockList= null;
      self.lastnameEN= "";
      self.lastnameTH= "";
      self.isBlockList = null;
      self.Active = null;
      self.EditStatus = false;
      self.VisitorDialog = false;
    },

    BindingEditData(data) {
      let self = this;
      self.id = data.id;
      self.prefixTH= data.prefixTH;
      self.prefixEN= data.prefixEN;
      self.blockListReason= data.blockListReason;
      self.documentNumber= data.documentNumber;
      self.firstnameEN= data.firstnameEN;
      self.firstnameTH= data.firstnameTH;
      self.isBlockList= data.isBlockList;
      self.lastnameEN= data.lastnameEN;
      self.lastnameTH= data.lastnameTH;
      self.isBlockList = data.isBlockList;
      self.Active = data.isBlockList;
      self.EditStatus = true;
      self.VisitorDialog = true;
    },

    CloseVisitorDialog() {
      let self = this;
      self.clear();
      
      self.VisitorDialog = false;
    },

    inActiveVisitorByVisitorID(id) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        VisitorID: id,
      };

      Swal.fire({
        title: "InActive",
        text: "Do you want to InActive this Member ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`${self.url}Visitor/inActiveVisitorByVisitorID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                self.getDataVisitor();
                Swal.fire(
                  "Deleted!",
                  "Your file has been Inactive.",
                  "success"
                );
              }
              if (response.data.status == 2) {
                eventBus.$emit("logout");
              }
              self.LoadingDialog = false;
            })
            .catch(function (error) {
              self.LoadingDialog = false;
              if (error.response.status != 404) {
                Swal.fire({
                  icon: "error",
                  title: "Error...",
                  width: 900,
                  text: error.response.data.message,
                });
              }
            });
          self.LoadingDialog = false;
        }
        self.LoadingDialog = false;
      });
    },

    ManageVisitor() {
      let self = this;
      self.LoadingDialog = true;
      
        let temp = {
            id: self.id,
            prefixTH: self.prefixTH,
            prefixEN: self.prefixEN,
            blockListReason: self.blockListReason,
            documentNumber: self.documentNumber,
            firstnameEN: self.firstnameEN,
            firstnameTH: self.firstnameTH,
            isBlockList: self.isBlockList,
            lastnameEN: self.lastnameEN,
            lastnameTH: self.lastnameTH,
        };
        axios
          .post(`${self.url}VMS/setVisitorBlockList`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.getDataVisitor();
              self.VisitorDialog = false;
              // self.LoadingDialog = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
          // 
            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
            // self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            if (error.response.status != 404) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            }
          });
    
    },
  },
};
</script>
<style scoped>
*>>>.v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}

*>>>.v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}

.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}

.validation-class {
  color: red;
  font-size: 12px;
}

.header-table-css {
  text-align: left;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1);
  }

  40% {
    transform: scaleY(0.4);
  }

  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}

.rect3 {
  animation-delay: -1.1s;
}

.rect4 {
  animation-delay: -1s;
}

.rect5 {
  animation-delay: -0.9s;
}
</style>
